import type { CollapseProps } from '@mantine/core';
import { Collapse } from '@mantine/core';
import { useEffect, useState } from 'react';

// This component is used to unmount the children when the collapse is closed (for performance reasons)
export function CollapseUnmount({ children, ...props }: CollapseProps) {
  const [childrenMounted, setChildrenMounted] = useState(props.in);
  const [isAnimating, setIsAnimating] = useState(props.in);

  useEffect(() => {
    if (props.in) {
      // First mount the children
      setChildrenMounted(true);
      // Then trigger the animation in the next frame
      const animationId = requestAnimationFrame(() => setIsAnimating(true));
      return () => cancelAnimationFrame(animationId);
    } else {
      // When closing, animate first
      setIsAnimating(false);
    }
  }, [props.in]);

  return (
    <Collapse
      {...props}
      in={isAnimating}
      onTransitionEnd={() => {
        if (!props.in) {
          setChildrenMounted(false);
        }
      }}
    >
      {!!childrenMounted && children}
    </Collapse>
  );
}
